export default __webpack_public_path__ + "static/media/arrow-right-000000.832449df.svg";